<div class="component-catalog">
  <div class="catalog-header">
    <h1>Catálogo de Componentes</h1>
    <p>Biblioteca de componentes reutilizables de la aplicación</p>
    
    <div class="search-container">
      <input 
        type="text" 
        placeholder="Buscar componentes..." 
        class="search-input"
        (input)="onSearchChange($event)">
    </div>
  </div>

  <div class="catalog-layout">
    <!-- Sidebar con lista de componentes -->
    <div class="sidebar">
      <div class="component-list">
        @for (component of filteredComponents; track component.id) {
          <div 
            class="component-item" 
            [class.active]="selectedComponent() === component.id"
            (click)="selectComponent(component.id)">
            <h4>{{ component.name }}</h4>
            <p>{{ component.description }}</p>
          </div>
        }
      </div>
    </div>

    <!-- Área principal con ejemplos -->
    <div class="main-content">
      @if (selectedComponent() === '') {
        <div class="welcome-message">
          <h2>Bienvenido al Catálogo de Componentes</h2>
          <p>Selecciona un componente de la lista para ver sus ejemplos de uso.</p>
        </div>
      } @else {
        @if (getSelectedComponent(); as component) {
          <div class="component-details">
            <div class="component-header">
              <h2>{{ component.name }}</h2>
              <p class="component-description">{{ component.description }}</p>
              <code class="selector">{{ component.selector }}</code>
            </div>

            <div class="examples-section">
              <h3>Ejemplos de Uso</h3>
              
              @for (example of component.examples; track example.title) {
                <div class="example-card">
                  <div class="example-header">
                    <h4>{{ example.title }}</h4>
                    <p>{{ example.description }}</p>
                  </div>

                  <div class="example-content">
                    <!-- Vista previa del componente -->
                    <div class="component-preview">
                      <h5>Vista Previa</h5>
                      <div class="preview-container">
                        @switch (component.id) {
                          @case ('capital-button') {
                            <app-capital-button 
                              [title]="example.props?.title || ''" 
                              [subtitle]="example.props?.subtitle || ''" 
                              [icon]="example.props?.icon || ''">
                            </app-capital-button>
                          }
                          @case ('capital-input') {
                            <app-capital-input 
                              [placeholder]="example.props?.placeholder || ''" 
                              [type]="example.props?.type || 'text'"
                              [formatter]="example.props?.formatter || ''">
                            </app-capital-input>
                          }
                          @case ('primary-button') {
                            <app-primary-button 
                              [text]="example.props?.text || ''" 
                              [disabled]="example.props?.disabled || false">
                            </app-primary-button>
                          }
                          @case ('capital-container') {
                            <app-capital-container 
                              [disablePaddings]="example.props?.disablePaddings || false"
                              [width]="example.props?.width || '78%'"
                              [size]="example.props?.size || 'L'"
                              [compactTop]="example.props?.compactTop || false">
                              <p>Contenido de ejemplo en el container</p>
                            </app-capital-container>
                          }
                          @case ('capital-card') {
                            <app-capital-card [shadow]="example.props?.shadow || 'normal'">
                              <h5>Título de ejemplo</h5>
                              <p>Contenido de ejemplo en la tarjeta</p>
                            </app-capital-card>
                          }
                          @case ('capital-back') {
                            <app-capital-back></app-capital-back>
                          }
                          @case ('capital-select') {
                            <app-capital-select 
                              [placeholder]="example.props?.placeholder || ''" 
                              [(ngModel)]="selectModel"
                              [options]="example.props?.options || sampleSelectOptions">
                            </app-capital-select>
                          }
                        }
                      </div>
                    </div>

                    <!-- Código del ejemplo -->
                    <div class="code-example">
                      <div class="code-header">
                        <h5>Código</h5>
                        <button 
                          class="copy-button"
                          (click)="copyCode(example.code)"
                          title="Copiar código">
                          📋
                        </button>
                      </div>
                      <pre><code>{{ example.code }}</code></pre>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>